import React, { useEffect, useRef, useState } from 'react';
import * as pdfjsLib from 'pdfjs-dist';
import styles from './Programacao.module.css';
import { Grid } from '@mui/material';
import { useDevice } from 'components/DeviceContext.js';

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const PDFViewer = ({ pdfConfig }) => {
    const canvasRef = useRef(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [pdf, setPdf] = useState(null);
    const [pageNumber, setPageNumber] = useState(pdfConfig.initialPage || 1); 
    const [numPages, setNumPages] = useState(null);
    const renderTaskRef = useRef(null); 
	const { isMobile } = useDevice();

    useEffect(() => {
        const loadPDF = async () => {
            try {
                const loadingTask = pdfjsLib.getDocument(pdfConfig.pdfUrl);
                const loadedPdf = await loadingTask.promise;
                setPdf(loadedPdf);
                setNumPages(loadedPdf.numPages);
                renderPage(loadedPdf, pageNumber);
            } catch (err) {
                setError("Falha ao carregar o PDF");
                console.error("Erro ao renderizar PDF: ", err);
            } finally {
                setLoading(false);
            }
        };

        loadPDF();
    }, [pdfConfig.pdfUrl, pageNumber]);

    const renderPage = async (loadedPdf, pageNum) => {
        if (!loadedPdf) return;

        if (renderTaskRef.current) {
            renderTaskRef.current.cancel();
        }

        const page = await loadedPdf.getPage(pageNum);
        const viewport = page.getViewport({ scale: 1.5 });
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');

        canvas.height = viewport.height;
        canvas.width = viewport.width;

        const renderContext = {
            canvasContext: context,
            viewport: viewport,
        };
        
        renderTaskRef.current = page.render(renderContext);
        try {
            await renderTaskRef.current.promise;
        } catch (error) {
            console.log("Renderização cancelada:", error);
        }
    };

    const handlePreviousPage = () => {
        if (pageNumber > 1 && pdf) {
            setPageNumber(pageNumber - 1);
            renderPage(pdf, pageNumber - 1);
        }
    };

    const handleNextPage = () => {
        if (pageNumber < numPages && pdf) {
            setPageNumber(pageNumber + 1);
            renderPage(pdf, pageNumber + 1);
        }
    };

    const handleDownloadPDF = () => {
        const link = document.createElement('a');
        link.href = pdfConfig.pdfUrl;
        link.download = pdfConfig.pdfUrl.split('/').pop(); 
        link.click();
    };

    return (
        <Grid container style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', paddingTop: '10em' }} className={styles['pdf-container']}>
            <Grid style={{ padding: isMobile ? '0' : '1em', fontSize: isMobile ? '0.6em' : '1em' }} className={styles['pdf-controls']}>
                <button onClick={handlePreviousPage} disabled={pageNumber <= 1}>Página Anterior</button>
                <span>Página {pageNumber} de {numPages}</span>
                <button onClick={handleNextPage} disabled={pageNumber >= numPages}>Próxima Página</button>
                <button onClick={handleDownloadPDF}>Baixar PDF</button>
                <button onClick={() => window.location.href = '/'}>Fechar</button>
                {loading && <div className={styles['pdf-loading']}>Carregando PDF...</div>}
                {error && <div className={styles['pdf-error']}>{error}</div>}
            </Grid>
            <canvas ref={canvasRef} className={styles['pdf-page-canvas']}></canvas>
        </Grid>
    );
};

export default PDFViewer;
